import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts'
import DisenrollmentReportActions from '../../Data/Redux/DisenrollmentReportRedux'
import CustomizedLegend from '../../Components/ReportsComponents/CustomizedLegend'
import Tool from '../../Components/ReportsComponents/Tool'
import ReportTemplate from './ReportTemplate'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'
import CentersExcelActions from '../../Data/Redux/CentersExcelRedux'

const COLORS = ['#152940', '#4B3F72', '#904C77', '#119DA4', '#53A2FF']

class Disenrollments extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
      data: [],
      reasons: [],
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getDisenrollmentReport } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'disenrollments')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'disenrollments')
      }
    } else {
      getDisenrollmentReport()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps(nextProps) {
    const newState = { ...this.state }
    const { disenrollmentReport, centersInfo, fromCenter } = nextProps
    const newData = []
    const reasons = []
    if (disenrollmentReport) {
      Object.keys(disenrollmentReport).map((key) => {
        const item = { date: key, formatDay: moment(key).format('MMM YYYY') }
        let total = 0
        Object.keys(disenrollmentReport[key]).map((reason) => {
          if (disenrollmentReport[key][reason].disenrollment_reason) {
            if (!reasons.includes(
              disenrollmentReport[key][reason].disenrollment_reason)) {
              reasons.push(
                disenrollmentReport[key][reason].disenrollment_reason)
            }
            item[disenrollmentReport[key][reason].disenrollment_reason] =
            disenrollmentReport[key][reason].total_disenrollments
            total += disenrollmentReport[key][reason].total_disenrollments
          } else {
            for (let i = 0; i < reasons.length; i++) {
              item[reasons[i]] = 0
            }
          }
        })
        item['total'] = total
        newData.push(item)
      })
      this.setState({ data: newData, reasons })
    }
    if (fromCenter) {
      Object.keys(centersInfo).map((key) => {
        const item = { date: key, formatDay: moment(key).format('MMM YYYY') }
        let total = 0
        Object.keys(centersInfo[key]).map((reason) => {
          if (centersInfo[key][reason].disenrollment_reason) {
            if (!reasons.includes(
              centersInfo[key][reason].disenrollment_reason)) {
              reasons.push(
                centersInfo[key][reason].disenrollment_reason)
            }
            item[centersInfo[key][reason].disenrollment_reason] =
            centersInfo[key][reason].total_disenrollments
            total += centersInfo[key][reason].total_disenrollments
          } else {
            for (let i = 0; i < reasons.length; i++) {
              item[reasons[i]] = 0
            }
          }
        })
        item['total'] = total
        newData.push(item)
      })
      this.setState({ data: newData, reasons })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  filter = ({ currentTarget: { id: reason } }) => {
    const newState = { ...this.state }
    const { disenrollmentReport } = this.props
    for (let i = 0; i < newState.data.length; i++) {
      if (newState.data[i][reason] && (newState.data[i][reason] !== 0 &&  newState.data[i][reason] !== null)) {
        newState.data[i][reason] = null
        const { date } = newState.data[i]
        const disenrollment = disenrollmentReport[date]
        Object.keys(disenrollment).map((key) => {
          if (disenrollmentReport[date][key].disenrollment_reason === reason) {
            newState.data[i]['total'] -= disenrollmentReport[date][key].total_disenrollments
          }
        })
      } else if (newState.data[i][reason] === 0 || newState.data[i][reason] === null) {
        const { date } = newState.data[i]
        const disenrollment = disenrollmentReport[date]
        Object.keys(disenrollment).map((key) => {
          if (disenrollmentReport[date][key].disenrollment_reason === reason) {
            newState.data[i]['total'] += disenrollmentReport[date][key].total_disenrollments
            newState.data[i][reason] = disenrollmentReport[date][key].total_disenrollments
          }
        })
      }
    }
    this.setState(newState)
  }

  aleatorio = (min, max) => {
    const posibilities = max - min
    let aleat = Math.random() * posibilities
    aleat = Math.floor(aleat)
    return parseInt(min) + aleat
}

  pickColor = (name) => {
    let count = 0
    for (let i = 0; i < this.state.data.length; i++) {
      if (this.state.data[i][name] && (this.state.data[i][name] !== 0 && this.state.data[i][name] !== null)) {
        count++
      }
    }
    return count > 0
  }

  download = () => {
    if (this.props.fromCenter) {
      this.props.getCentersExcel('disenrollments', this.props.activeCenter)
    } else {
      this.props.getDisenrollmentExcel()
    }
  }

  renderOptions = () => {
    const reasonsToRender = this.state.reasons.map((reason, index) => {
      const hexadecimal = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E', 'F']
      let color = '#'
      for (let i = 0; i < 6; i++) {
        const posarray = this.aleatorio(0, hexadecimal.length)
        color += hexadecimal[posarray]
      }
      return (
        <Bar key={index} stackId="a" dataKey={reason} fill={this.pickColor(reason) ? COLORS[index % COLORS.length] : 'gray'} />
      )
    })
    return (
      reasonsToRender
    )
  }

  render() {
    const { fromCenter } = this.props
    const { width, data } = this.state
    return (
      <ReportTemplate
        title="Bajas/Motivo"
        date={data[0] &&
          { initial: data[0].date, end: data[data.length - 1].date }}
        onClick={this.download}
        loading={!data[0]}
      >
        {data[0] &&
          <BarChart
            width={width < 763 ? 400 : 648}
            height={width < 763 ? 300 : 400}
            data={data}
            margin={{ top: 40, right: 50, left: 10, bottom: 40 }}
          >
            <CartesianGrid vertical={false} />
            <XAxis dataKey="formatDay" />
            <YAxis />
            <Tooltip content={<Tool withoutCurrency />} />
            <Legend content={<CustomizedLegend onClick={!fromCenter && this.filter} />} />
            {this.renderOptions()}
          </BarChart>
        }
      </ReportTemplate>
    )
  }
}


const mapStateToProps = ({ disenrollmentReport, centersInfo }) => ({
  disenrollmentReport: disenrollmentReport.get.results,
  centersInfo: centersInfo.disenrollments.results,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getDisenrollmentReport: () => dispatch(DisenrollmentReportActions.getRequest({}, true)),
  getDisenrollmentExcel: () => dispatch(DisenrollmentReportActions.DisenrollmentExcelRequest()),
  getCentersExcel: (path, centerId) => dispatch(CentersExcelActions.CentersExcelRequest(path, centerId)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Disenrollments))



// WEBPACK FOOTER //
// ./src/Containers/Reports/Disenrollments.jsx